/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import TextLink from "../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../components/TextLink/types";
import useLogin from "../hooks/useLogin";

interface BackToSignInProps {
  handleClick: () => void;
}

const BackToSignIn = ({ handleClick }: BackToSignInProps) => {
  const { generateVerificationDescription } = useLogin();
  const { t } = useTranslation();

  return (
    <div>
      <Typography
        variant="body1Medium"
        component="div"
        css={css({
          marginBottom: "8px"
        })}
      >
        {generateVerificationDescription(t)}
      </Typography>

      <TextLink size={TEXT_LINK_SIZES.Normal} onClick={handleClick}>
        {t("Auth##back to sign in screen")}
      </TextLink>
    </div>
  );
};

export default BackToSignIn;
